import { createSlice } from "@reduxjs/toolkit";

const initialState = { coupons: [], couponDetails: null };

export const couponSlice = createSlice({
  name: "coupon",
  initialState,
  reducers: {
    setCouponList: (state = initialState, { payload }) => {
      return {
        ...state,
        coupons: payload,
      };
    },

    setCouponDetails: (state = initialState, { payload }) => {
      return {
        ...state,
        couponDetails: payload,
      };
    },

    addCoupon: (state = initialState, { payload }) => {
      return {
        ...state,
        coupons: [...state.coupons, payload],
      };
    },

    updateCoupon: (state = initialState, { payload }) => {
      return {
        ...state,
        coupons: state.coupons.map((coupon) =>
          coupon._id === payload._id ? payload : coupon
        ),
      };
    },

    deleteCoupon: (state = initialState, { payload }) => {
      return {
        ...state,
        coupons: state.coupons.filter((coupon) => coupon._id !== payload),
      };
    },
  },
});
